import React from 'react'
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CircleIcon from '@mui/icons-material/Circle';
import { useSelector } from 'react-redux';

const WatlistArrow = ({ symbolId }) => {
    const row = useSelector(state => state.updateSymbol.symbols?.[symbolId])
    return (
        <>
            {
                row?.bidColor === 'up' ?
                    <ArrowDropUpIcon sx={{ color: "green", fontSize: "25px", marginRight: "2px" }} /> :
                    row?.bidColor === 'down' ? <ArrowDropDownIcon sx={{ color: "red", fontSize: "25px", marginRight: "2px" }} /> : <CircleIcon sx={{ color: "#aaa", fontSize: "8px", marginRight: "10px", marginLeft: '7px' }} />
            }
        </>
        
    )
}

export default WatlistArrow